/** Longest edge sent to any AI feature. 2048² matches the tightest vendor pixel cap. */
export const AI_INPUT_MAX_EDGE = 2048;

/** Files already under this size and the edge cap are uploaded unchanged. */
export const AI_INPUT_SKIP_BYTES = 8 * 1024 * 1024;

export const AI_JPEG_QUALITY = 0.92;

/** Classify runs under about 1 megapixel. Tighter than the shared 2048 working copy. */
export const CLASSIFY_MAX_PIXELS = 1048576;
